module.exports = __webpack_public_path__ + "img/shwy.f91c1981.png";